import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { REFRESH_SOURCE_FAILURE } from '../../model/constants';
import { loadAppData, refreshDataRequest } from '../../state/actions/app';
import {
	type CardsBulkOperationsSuccessAction,
	type CardsBulkOperationsFailureAction,
	CARDS_BULK_OPERATIONS_SUCCESS,
	CARDS_BULK_OPERATIONS_FAILURE,
} from '../../state/actions/cards/bulk-operations';
import type { ActionsObservable } from '../../state/types';

export const cardsBulkOperationsFailureEpic = (action$: ActionsObservable) =>
	action$
		.ofType(CARDS_BULK_OPERATIONS_FAILURE)
		.flatMap((action: CardsBulkOperationsFailureAction) => {
			if (action.payload.length === 0) {
				return Observable.empty<never>();
			}
			return Observable.of(refreshDataRequest(REFRESH_SOURCE_FAILURE));
		});

export const cardsBulkOperationsSuccessEpicCmp = (action$: ActionsObservable) =>
	action$
		.ofType(CARDS_BULK_OPERATIONS_SUCCESS)
		.flatMap((action: CardsBulkOperationsSuccessAction) => {
			if (action.payload.length === 0) {
				return Observable.empty<never>();
			}
			return Observable.of(loadAppData());
		});
